import AboutUs from "../../views/support/AboutUs";
import WarrantyInfo from "../../views/support/WarrantyInfo";
import TermsCondition from "../../views/support/TermsCondition";
import PrivacyPolicy from "../../views/support/PrivacyPolicy";
import SupportLayout from "../../views/support/Layout";

import ContactUs from "../../views/support/ContactUs";
import RefundExchange from "../../views/support/RefundExchange";
import WarrantyRegister from "../../views/support/WarrantyRegister";
import Faq from "../../views/support/Faq";
import FaqSubject from "../../views/support/FaqSubject";

export default [
  {
    path: "/support",
    component: SupportLayout,
    meta: { title: "Support" },
    children: [
      {
        path: "about_us",
        component: AboutUs,
        meta: { title: "About Us" }
      },
      {
        path: "warranty",
        component: WarrantyInfo,
        meta: { title: "Warranty" }
      },
      {
        path: "terms_condition",
        component: TermsCondition,
        meta: { title: "Terms of Use" }
      },
      {
        path: "privacy_policy",
        component: PrivacyPolicy,
        meta: { title: "Privacy Policy" }
      },
      {
        path: "contact_us",
        component: ContactUs,
        meta: { title: "Customer Service" }
      },
      {
        path: "refund_exchange",
        component: RefundExchange,
        meta: { title: "Customer Service" }
      },

      {
        path: "warranty_register",
        component: WarrantyRegister,
        meta: { title: "Customer Service" }
      },
      {
        path: "faq",
        component: Faq,
        meta: { title: "Customer Service" },
        redirect: "/support/faq/scale",
        children: [
          {
            path: ":subject",
            component: FaqSubject,
            props: route => ({
              subject: route.params.subject
            }),
            meta: { title: "Customer Service" }
          }
        ]
      }
    ]
  }
];
